import styled from 'styled-components'
import theme from 'theme'

export const DashboardTileControlsWrapper = styled.div`
  display: flex;
  gap: ${theme.spacing.xs};
`
